export default __webpack_public_path__ + "static/B0057-2d8e2083d249166d3d4c57c573d5b092.png";